export const TOGGLE_DARKMODE = "TOGGLE_DARKMODE";
export const toggle_darkmode = () => ({ type: TOGGLE_DARKMODE });
